// @flow
import filterDataItems from './filterDataItems';


const filterId: 'filterData' = 'filterData';
export default filterId;
export { filterDataItems };
